import React, { useState, useEffect } from "react";
import { Row, Col, Modal, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { listDocuments } from "../actions/documentActions";
import DashHeader from "./DashHeader";
import Loader from "./Loader";
import { Helmet } from "react-helmet-async";
import axios from "axios";
import GeneratedDocs from "./GeneratedDocs";
import UploadedDocs from "./UploadedDocs";
import UserValidator from "./UserValidator";
import { pushLinkToGlobalState } from "../actions/linkActions";

function Documents() {
  const dispatch = useDispatch();

  const documentList = useSelector((state) => state.documentList);
  const { documents } = documentList;
  const { userInfo } = useSelector((state) => state.userLogin);

  const [queryingDocs, setQueryingDocs] = useState(true);

  let currentUrl = window.location.href;
  let index = currentUrl.indexOf("/dashboard");
  let splitUrl = currentUrl.substring(index);
  dispatch(pushLinkToGlobalState(splitUrl));

  /* Modal Management */
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);

  const [loader, setLoader] = useState(false);

  const [generatedDocsShow, setGeneratedDocsShow] = useState(true);
  const [uploadedDocsShow, setUploadedDocsShow] = useState(false);
  const [componentToRefresh, setComponentToRefresh] = useState(false);

  function handleModalShow() {
    setShow(true);
  }

  function handleModalClose() {
    setShow(false);
    setLoader(false);
    setError(false);
    setMessage("");
    setFileTypeErrorMessage("");
  }

  function handleModal2Show() {
    setShow2(true);
  }

  function handleModal2Close() {
    setShow2(false);
  }

  function handleGeneratedDocsShow() {
    setUploadedDocsShow(false);
    setGeneratedDocsShow(true);
  }

  function handleUploadedDocsShow() {
    setGeneratedDocsShow(false);
    setUploadedDocsShow(true);
    console.log('document', document)
  }

  function refreshComponent() {
    // console.log("refreshed");
    setComponentToRefresh((prev) => !prev);
  }

  useEffect(() => {
    dispatch(listDocuments());
    console.log("documents dispatched");
  }, [dispatch, componentToRefresh]);

  useEffect(() => {
    setQueryingDocs((queryingDocs) => !queryingDocs);
  }, [documents]);

  /* Sorting Stuff */

  const [sortedDocs, setSortedDocs] = useState("");

  useEffect(() => {
    setSortedDocs(documents);
  }, [documents]);
  const [sortDocs, setSortDocs] = useState(true);

  
  function changeSort() {
   
    setSortDocs((prevState) => {
      return !prevState;
    });

    const sorted = sortDocs
      ? [...sortedDocs].sort((a, b) => b.id - a.id)
      : [...sortedDocs].sort((a, b) => a.id - b.id);
    setSortedDocs(sorted);
    
    return sortedDocs;
  }

  /* Doc Upload Functions */

  const [file, setFile] = useState(null);
  const [userDocName, setUserDocName] = useState("");
  const [docName, setDocName] = useState(false);
  const [error, setError] = useState(false);
  const [message, setMessage] = useState("");
  const [fileAllowed, setFileAllowed] = useState();
  const [fileTypeErrorMessage, setFileTypeErrorMessage] = useState("");

  function submitDocName(e) {
    setDocName(e.target.value);
  }

  function submitUserDocName(e) {
    setUserDocName(e.target.value);
  }

  function handleFile(e) {
    const fileVar = e.target.files[0];
    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];
    if (allowedTypes.includes(fileVar.type)) {
      setFileAllowed(true);
      setFile(fileVar);
    } else {
      setFileAllowed(false);
      setFileTypeErrorMessage("Sorry, that file type is not allowed");
    }
    // console.log("e.target.files[0]", e.target.files[0]);
  }

  function handleUpload(e) {
    e.preventDefault();
    setLoader(true);
    if (fileAllowed) {
      let formData = new FormData();
      formData.append("file", file);
      const config1 = {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
      const config2 = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
      axios
        .post("/api/documents/upload-document/", formData, config1)
        .then(function (response) {
          const url = response.data.url;
          // console.log("response", response);
          axios
            .post(
              "/api/documents/add-uploaded-document/",
              { url: url, title: docName, userTitle: userDocName },
              config2
            )
            .then(function (response) {
              setLoader(false);
              setComponentToRefresh((prev) => !prev);
              setMessage("Your document was successfully uploaded"); //upload success
            })
            .catch(function (error) {
              setLoader(false);
              setError(
                "There was an error saving you document to the database"
              );
            });
        })
        .catch(function (error) {
          setLoader(false);
          setError("There was an error uploading your document"); //upload fail
        });
    } else {
    }
  }

  return (
    <>
      <Helmet>
        <title>Your Generated Documents</title>
        <meta
          name="description"
          content="Lacoona Legals library of your generated documents"
        />
        <link rel="canonical" href="/dashboard/documents" />
      </Helmet>
      {userInfo?.profile === 1 ? (
        <Col className="dashboard-scrollable-container" lg={9}>
          <DashHeader pageTitle={"Documents"} />
          <Row className="dashboard-content-container">
            <Row className="dashboard-content-divider"></Row>
            <Row>
              <Col lg={10} sm={6}>
                <h2 className="ll-subtitle ll-feat-font">My Documents</h2>
              </Col>
              <Col lg={2} sm={6}>
                <button
                  onClick={handleModalShow}
                  className="lcn-button-orange px-3"
                >
                  <i class="fa-solid fa-arrow-up-from-bracket me-4"></i>
                  Upload
                </button>
              </Col>
            </Row>
            <Row className="mt-5">
              <Row className="health-check-form-categories p-0">
                <Col
                  onClick={handleGeneratedDocsShow}
                  className={generatedDocsShow ? "active-tab" : "tab"}
                >
                  <div align="center">
                    <i class="fa-regular fa-file-lines me-4 pt-1"></i>Generated
                  </div>
                </Col>
                <Col
                  onClick={handleUploadedDocsShow}
                  className={uploadedDocsShow ? "active-tab" : "tab"}
                >
                  <div align="center">
                    <i class="fa-solid fa-file-import me-4 pt-1"></i>Uploaded
                  </div>
                </Col>
              </Row>
            </Row>

            <Row className="m-3 doc-card-headers">
              <Col lg={4}>
                <h5>Document Title</h5>
              </Col>
              <Col className="d-flex" lg={8}>
                <h5>Drafted Date</h5>
                <button
                  className="documents--sort-button"
                  onClick={() => changeSort()}
                >
                  ⇅
                </button>
              </Col>
            </Row>

            {/* Generated Documents */}

            {generatedDocsShow && (
              <GeneratedDocs
                documents={sortedDocs}
                queryingDocs={queryingDocs}
             
              />
            )}
            {uploadedDocsShow && (
              <UploadedDocs
                refreshComponent={refreshComponent}
                documents={sortedDocs}
                queryingDocs={queryingDocs}
                handleModal2Show={handleModal2Show}
                handleModal2Close={handleModal2Close}
                
                
              />
            )}
          </Row>
          <Row>
            <Modal show={show} onHide={handleModalClose}>
              <Modal.Header closeButton>
                <Modal.Title>Upload a document</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form onSubmit={handleUpload}>
                  <Form.Group>
                    <Form.Label>
                      Please select the type of document you'd like to upload
                    </Form.Label>
                    <Form.Select
                      onChange={submitDocName}
                      value={docName !== false ? docName : "DEFAULT"}
                    >
                      <option value="DEFAULT" disabled>
                        Choose a value
                      </option>
                      <option value="Board: Notice of meeting">
                        Board: Notice of meeting
                      </option>
                      <option value="Confidentiality and IP Assignment Agreement (Plain language)">
                        Confidentiality and IP Assignment Agreement (Plain
                        language)
                      </option>
                      <option value="Consulting Agreement">
                        Consulting Agreement
                      </option>
                      <option value="Contract for the Sale of Goods">
                        Contract for the Sale of Goods
                      </option>
                      <option value="Contract of Employment">
                        Contract of Employment
                      </option>
                      <option value="End-user License Agreement">
                        End-user License Agreement
                      </option>
                      <option value="Founders Collaboration Agreement">
                        Founders Collaboration Agreement
                      </option>
                      <option value="Independent Contractor Agreement">
                        Independent Contractor Agreement
                      </option>
                      <option value="Joint-venture Agreement">
                        Joint-venture Agreement
                      </option>
                      <option value="Letter of Demand for Overdue account">
                        Letter of Demand for Overdue account
                      </option>
                      <option value="Memorandum of Agreement">
                        Memorandum of Agreement
                      </option>
                      <option value="Memorandum of Incorporation">
                        Memorandum of Incorporation
                      </option>
                      <option value="Non-disclosure Agreement">
                        Non-disclosure Agreement
                      </option>
                      <option value="Ordinary Board Resolution">
                        Ordinary Board Resolution
                      </option>
                      <option value="PAIA Manual Template for Private Bodies">
                        PAIA Manual Template for Private Bodies
                      </option>
                      <option value="POPIA Compliance Manual">
                        POPIA Compliance Manual
                      </option>
                      <option value="POPIA Data Privacy Policy">
                        POPIA Data Privacy Policy
                      </option>
                      <option value="POPIA Employee's Consent">
                        POPIA Employee's Consent
                      </option>
                      <option value="Partnership Agreement">
                        Partnership Agreement
                      </option>
                      <option value="Round Robin Resolution">
                        Round Robin Resolution
                      </option>
                      <option value="SAFE Note Agreement">
                        SAFE Note Agreement
                      </option>
                      <option value="Service Level Agreement">
                        Service Level Agreement
                      </option>
                      <option value="Share Certificate">
                        Share Certificate
                      </option>
                      <option value="Shareholder Agreement: For-Profit">
                        Shareholder Agreement: For-Profit
                      </option>
                      <option value="Shareholder Loan Agreement">
                        Shareholder Loan Agreement
                      </option>
                      <option value="Shareholders Operating Agreement">
                        Shareholders Operating Agreement
                      </option>
                      <option value="Small Claims Court Letter of Demand">
                        Small Claims Court Letter of Demand
                      </option>
                      <option value="Special Board Resolution">
                        Special Board Resolution
                      </option>
                      <option value="Technology Assignment Agreement">
                        Technology Assignment Agreement
                      </option>
                      <option value="Website Privacy Policy">
                        Website Privacy Policy
                      </option>
                      <option value="Website Terms of Service (Terms & Conditions of Use Policy)">
                        Website Terms of Service (Terms & Conditions of Use
                        Policy)
                      </option>
                      <option value="Website design and development agreement">
                        Website design and development agreement
                      </option>
                      <option value="Written notice of retrenchment">
                        Written notice of retrenchment
                      </option>
                    </Form.Select>
                  </Form.Group>
                  <Form.Group className="mt-3">
                    <Form.Label>Please give this document a name</Form.Label>
                    <Form.Control
                      required
                      type="text"
                      onChange={submitUserDocName}
                    ></Form.Control>
                  </Form.Group>
                  <Form.Group className="mt-3">
                    <Form.Control
                      type="file"
                      onChange={handleFile}
                      // accept=".pdf, .doc, .docx"
                    />
                  </Form.Group>
                  <Col align="center" className="mt-3">
                    {!loader && !message && !error && !fileTypeErrorMessage && (
                      <button className="lcn-button-orange" type="submit">
                        Upload
                      </button>
                    )}

                    {loader && <Loader />}
                    {message && (
                      <div className="success-message">{message}</div>
                    )}
                    {error && <div className="error-message">{error}</div>}
                    {fileTypeErrorMessage && (
                      <div className="error-message">
                        {fileTypeErrorMessage}
                      </div>
                    )}
                  </Col>
                </Form>
              </Modal.Body>
              <Modal.Footer></Modal.Footer>
            </Modal>

            {/* modal for confirming doc deletion */}
            <Modal show={show2} onHide={handleModal2Close}>
              <Modal.Header closeButton>
                <Modal.Title>Delete a document</Modal.Title>
              </Modal.Header>
              <Modal.Body>Your document has been deleted.</Modal.Body>
            </Modal>
          </Row>
        </Col>
      ) : (
        <Col className="dashboard-scrollable-container">
          <Row className="dashboard-content-container">
            <Col align="center" className="mt-5 pt-5">
              <h3>Unfortunately this page is only available to SMEs</h3>
            </Col>
          </Row>
        </Col>
      )}
      {!userInfo ? (
        <UserValidator />
      ) : (
        userInfo?.profile === 0 && <UserValidator />
      )}
    </>
  );
}

export default Documents;
